import join from 'url-join';

import { asyncAction, http } from '../util';

export const getFeature = asyncAction({
  baseName: 'GET_FEATURE_FLAG',
  action: action => featureKey => dispatch => {
    dispatch(action.start());
    return http
      .get(join(import.meta.env.VITE_API_URL, `feature/v1/${featureKey}`))
      .then(({ data: response }) => dispatch(action.success({ featureKey, response })))
      .catch(err => dispatch(action.error(err)));
  }
});
